import { SponsoredCarouselProps } from './types';

export const getLimitedSponsoredProducts = <T = unknown>(
  products: T[] | null,
  { isMobile, isDesktop }: { isMobile?: boolean; isDesktop?: boolean },
  sponsored: Pick<SponsoredCarouselProps, 'limitMin' | 'limitMax' | 'limitMinMobile' | 'limitMaxMobile'>,
): T[] => {
  const { limitMin, limitMinMobile, limitMax, limitMaxMobile } = sponsored;

  if (!products) return [];

  if (!limitMin && !limitMinMobile && !limitMax && !limitMaxMobile) return products;

  const limitProducts = (productsToLimit: T[], min?: number, max?: number) => {
    const limitedByMax = max ? productsToLimit.slice(0, max) : productsToLimit;

    const limitedByMin = (min && limitedByMax.length >= min) || !min ? limitedByMax : [];

    return limitedByMin;
  };

  if (isDesktop) return limitProducts(products, limitMin, limitMax);

  if (isMobile) return limitProducts(products, limitMinMobile, limitMaxMobile);

  return products;
};

export const detectDeviceFromUserAgent = (userAgent: string): { isMobile: boolean; isDesktop: boolean } => {
  const uaLower = userAgent.toLowerCase();

  const isMobile = /mobile|android|iphone|ipad|ipod|windows phone/i.test(uaLower);
  const isTablet = /tablet|ipad/i.test(uaLower) && !/mobile/i.test(uaLower);

  return {
    isMobile: isMobile || isTablet,
    isDesktop: !isMobile && !isTablet,
  };
};
